import { HttpInterceptorFn } from '@angular/common/http';
import { API_PATHS, STORAGE_KEYS } from '../common/constants/common.constants';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  let token: string | null = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  if (req.url.endsWith(API_PATHS.VERIFY_2FA) && req.headers.get('isTfaToken') === 'true') {
    token = localStorage.getItem(STORAGE_KEYS.TEMP_ACCESS_TOKEN);
  }
  req = req.clone({
    setHeaders: {
      Authorization: "Bearer " + token
    }
  });

  return next(req);
};
